import store from '../store'
import PGSHelper from '../helpers/PGSHelper.js';
import { V } from '../helpers/ValidationRules';

export default class Producto {
  static typeSearch = "local" //online || local
  static rules = {
    Nombre: [
      V.required('El Nombre es obligatorio'),
      V.minLength(2, 'El nombre debe tener al menos 2 caracteres'),
    ],
    Marca: [V.required('La Marca es obligatoria')],
    Categoria: [V.required('La Categoría es obligatoria')],
    Departamento: [V.requiredSelect('El Departamento es obligatorio')],
    Tipo: [V.required('El Tipo de producto es obligatorio')],
    Precio: [
      V.numeric('El precio debe ser un número válido'),
      V.nonNegative('El precio no puede ser negativo'),
    ],
    Codigo: [(value) => parseFloat(value) >= 0 || 'El Código es obligatorio'],
    Requerido: [V.required('El campo es obligatorio')],
    Porcentaje: [V.percentage('Debe ser un porcentaje válido (0% - 100%)')],
    Merma: [
      (value) => (value !== '' && value !== null && value !== undefined && String(value).trim() !== '') || 'La Merma es obligatoria',
      V.percentage('Debe ser un porcentaje válido (0% - 100%)'),
    ],
  }
  static tiposProducto = [
    { id: "Producto", name: "Producto con inventario" },
    { id: "Producto-NInv", name: "Producto sin inventario" },
    { id: "AYB-Producto", name: "Producto AYB" },
    { id: "AYB-Insumo", name: "Insumo AYB" },
    { id: "AYB-ICompuesto", name: "Subreceta" }
    /*{id:"Producto-SSal",name:"Producto de solo salidas"}*/
  ]

  static tiposUm = [
    "KGS",
    "LTS",
    "LBS",
    "PZA",
    "OZ",
    "GALON",
    "PAQUETE",
    "LATA",
    "GR",
    "ML",
    "PORCIONES"
  ]

  constructor(data = null) {
    this.Nombre = (data?.Nombre) ? data.Nombre : '';
    this.Marca = (data?.Marca) ? data.Marca : '';
    this.Catalogo = (data?.Catalogo) ? data.Catalogo : [];
    this.Precio = (data?.Precio) ? data.Precio : 0;
    this.Categoria = (data?.Categoria) ? data.Categoria : '';
    this.Departamentos = (data?.Departamentos) ? data.Departamentos : [];
    this.CCs = (data?.CCs) ? data.CCs : null;
    this.Moneda = (data?.Moneda) ? data.Moneda : '';
    this.FechaCreacion = (data?.FechaCreacion || null)
    this.CodigoSat = (data?.CodigoSat) ? data.CodigoSat : '';
    this.Origen = (data?.Origen) ? data.Origen : null;
    this.Alerta = (data?.Alerta) ? data.Alerta : 0;
    this.PrecioVariable = (data?.PrecioVariable) ? data.PrecioVariable : false;
    // Retrocompatibilidad: backend espera 'Id' y frontend/logs esperan 'id'
    const id = data?.id || data?.Id || null;
    this.Id = id;
    this.id = id;
    this.Orden = (data?.Orden) ? data.Orden : 0;
    this.amcs = (data?.amcs) ? data.amcs : {};
    this.Codigo = (data?.Codigo) ? data.Codigo : "";
    this.CodigoBarras = (data?.CodigoBarras) ? data.CodigoBarras : "";
    this.Tipo = (data?.Tipo) ? data.Tipo : "";
    this.Modificadores = (data?.Modificadores) ? data.Modificadores : null;
    this.Ingredientes = (data?.Ingredientes) ? data.Ingredientes : null;
    this.Vaun = (data?.Vaun) ? data.Vaun : null;
    this.Dlat = (data?.Dlat) ? data.Dlat : null;
    this.Extra = (data?.Extra) ? data.Extra : {};
    this.dscr = (data?.dscr) ? data.dscr : null;
    this.dcdg = (data?.dcdg) ? data.dcdg : false;
    this.opdv = (data?.opdv) ? data.opdv : false;
    this.oweb = (data?.oweb) ? data.oweb : false;
    this.ocmd = (data?.ocmd) ? data.ocmd : false;
    this.imgn = (data?.imgn) ? data.imgn : false;
    this.tags = (data?.tags) ? data.tags : [];
    this.fcmp = (data?.fcmp) ? data.fcmp : 0;
    this.ftlr = (data?.ftlr) ? data.ftlr : 0;
    this.eidl = (data?.eidl) ? data.eidl : 0;
    this.Tenant = (data?.Tenant) ? data.Tenant : null
  }

  static getRules() {
    return this.rules;
  }

  static getTiposProducto() {
    return this.tiposProducto;
  }

  static getTiposUm() {
    return this.tiposUm;
  }

  static getPropertyModel() {
    return this;
  }

  addModificador(data) {
    if (!this.Modificadores) {
      this.Modificadores = [];
    }
    this.Modificadores.push(data);
  }

  deleteModificador(index) {
    this.Modificadores.splice(index, 1);
  }

  addIngredientes(data) {
    if (!this.Ingredientes) {
      this.Ingredientes = [];
    }
    this.Ingredientes.push(data);
  }

  deleteIngredientes(index) {
    this.Ingredientes.splice(index, 1);
  }

  setAsService() {
    this.Tipo = 'Servicio';
    this.Marca = ""
  }

  setTipo(tip) {
    this.Tipo = tip;
  }

}